<template>
  <div></div>
</template>

<script>
export default {
  mounted() {
    this.$store.dispatch("logout").then(() => {
      this.$router.push("/login").then(() => {
        // window.location.reload();
      });
    });
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss">
body {
  background-color: #ffffff;
}
</style>
